<template>
  <div class="header">
    <div :class="[`header__${changeHgLogo ? 'hgConnectLogo' : 'logo'}`]"></div>
  </div>
</template>

<script>
export default {
  computed: {
    changeHgLogo() {
      const changeLogoPath = '/welcome/offers';
      return this.$route.path === changeLogoPath;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  max-width: 825px;
  width: 100%;
  margin: 32px auto 0px;
  &__logo {
    background: url(../../../assets/hg-bg.png);
    background-size: cover;
    width: 143px;
    height: 25px;
  }
  &__hgConnectLogo {
    background: url(../../../assets/hgConnectLogo.png);
    background-size: cover;
    width: 143px;
    height: 37px;
  }
  @media all and (max-width: 829px) {
    padding-left: 15px;
  }
  @media all and (max-width: 655px) {
    margin-bottom: 32px;
  }
}
</style>
